import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { GoSortAsc } from "react-icons/go";
import { Sort } from "@models";

const SortIcon: FCX<{
	direction: Sort;
}> = ({
	direction,
    className,
    children,
    ...props
}) => {
    return (
        <GoSortAsc
            className={cn(
                "SortIcon",
	            direction === Sort.Desc && 'is-desc',
                className,
            )}
            {...props}
        />
    );
};

export default SortIcon;